'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _awaitAsyncGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _asyncIterator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var parallelBatch = require('it-parallel-batch');

var defaultOptions = require('./options');
/**
 * @typedef {import('./types').BlockAPI} BlockAPI
 * @typedef {import('./types').ImportCandidate} ImportCandidate
 * @typedef {import('./types').UserImporterOptions} UserImporterOptions
 * @typedef {import('./types').ImporterOptions} ImporterOptions
 * @typedef {import('./types').Directory} Directory
 * @typedef {import('./types').File} File
 * @typedef {import('./types').ImportResult} ImportResult
 *
 * @typedef {import('./types').Chunker} Chunker
 * @typedef {import('./types').DAGBuilder} DAGBuilder
 * @typedef {import('./types').TreeBuilder} TreeBuilder
 * @typedef {import('./types').BufferImporter} BufferImporter
 * @typedef {import('./types').ChunkValidator} ChunkValidator
 * @typedef {import('./types').Reducer} Reducer
 * @typedef {import('./types').ProgressHandler} ProgressHandler
 */

/**
 * @param {AsyncIterable<ImportCandidate> | Iterable<ImportCandidate> | ImportCandidate} source
 * @param {BlockAPI} block
 * @param {UserImporterOptions} options
 */


function importer(_x, _x2) {
  return _importer.apply(this, arguments);
}

function _importer() {
  _importer = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(source, block) {
    var options,
        opts,
        dagBuilder,
        treeBuilder,
        candidates,
        _iteratorAbruptCompletion,
        _didIteratorError,
        _iteratorError,
        _iterator,
        _step,
        entry,
        _args = arguments;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            options = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
            opts = defaultOptions(options);

            if (typeof options.dagBuilder === 'function') {
              dagBuilder = options.dagBuilder;
            } else {
              dagBuilder = require('./dag-builder');
            }

            if (typeof options.treeBuilder === 'function') {
              treeBuilder = options.treeBuilder;
            } else {
              treeBuilder = require('./tree-builder');
            }
            /** @type {AsyncIterable<ImportCandidate> | Iterable<ImportCandidate>} */


            if (Symbol.asyncIterator in source || Symbol.iterator in source) {
              // @ts-ignore
              candidates = source;
            } else {
              // @ts-ignore
              candidates = [source];
            }

            _iteratorAbruptCompletion = false;
            _didIteratorError = false;
            _context.prev = 7;
            _iterator = _asyncIterator(treeBuilder(parallelBatch(dagBuilder(candidates, block, opts), opts.fileImportConcurrency), block, opts));

          case 9:
            _context.next = 11;
            return _awaitAsyncGenerator(_iterator.next());

          case 11:
            if (!(_iteratorAbruptCompletion = !(_step = _context.sent).done)) {
              _context.next = 18;
              break;
            }

            entry = _step.value;
            _context.next = 15;
            return {
              cid: entry.cid,
              path: entry.path,
              unixfs: entry.unixfs,
              size: entry.size
            };

          case 15:
            _iteratorAbruptCompletion = false;
            _context.next = 9;
            break;

          case 18:
            _context.next = 24;
            break;

          case 20:
            _context.prev = 20;
            _context.t0 = _context["catch"](7);
            _didIteratorError = true;
            _iteratorError = _context.t0;

          case 24:
            _context.prev = 24;
            _context.prev = 25;

            if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
              _context.next = 29;
              break;
            }

            _context.next = 29;
            return _awaitAsyncGenerator(_iterator.return());

          case 29:
            _context.prev = 29;

            if (!_didIteratorError) {
              _context.next = 32;
              break;
            }

            throw _iteratorError;

          case 32:
            return _context.finish(29);

          case 33:
            return _context.finish(24);

          case 34:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[7, 20, 24, 34], [25,, 29, 33]]);
  }));
  return _importer.apply(this, arguments);
}

module.exports = {
  importer: importer
};